<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>ADD DEVICE</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="p-6">
        <ul label="Category" class="centerx">
          <li>
            <vs-radio v-model="input_type" vs-value="single">Single</vs-radio>
          </li>
          <li>
            <vs-radio v-model="input_type" vs-value="bulk">Bulk</vs-radio>
          </li>
        </ul>
        <!-- NAME -->
        <vs-input
          v-if="input_type=='single'"
          label="Device Name"
          name="device name"
          v-model="device_name"
          class="mt-5 w-full"
        />
        <vs-input
          v-if="input_type=='bulk'"
          label="Device Prefix Name"
          name="device prefix name"
          v-model="prefix_name"
          :disabled="disabled == true"
          class="mt-5 w-full"
        />
        <vs-input
          label="Description"
          name="descriptions"
          v-model="description"
          class="mt-5 w-full"
        />
        <!-- PRICE -->
        <vs-input
          v-if="input_type=='bulk'"
          label="Quantity"
          name="Qty"
          v-model="qty"
          class="mt-5 w-full"
        />
      </div>
      <div class="flex flex-row-reverse p-6 mt-16">
        <vs-button v-if="input_type=='bulk'" class="mr-6" @click="generateDevice">Generate</vs-button>
        <vs-button v-if="input_type=='single'" class="mr-6" @click="addSingle">Confirm</vs-button>
        <vs-button
          type="border"
          class="mr-6"
          color="danger"
          @click="isSidebarActiveLocal = false"
        >Cancel</vs-button>
      </div>
    </VuePerfectScrollbar>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    callback: { type: Function, required: true },
    counter: {type:Number, required:true}
  },
  data() {
    return {
      device_name: "",
      prefix_name: "",
      input_type: "single",
      description: "",
      disabled:false,
      qty: 0,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          //this.initValues();
        }
      }
    }
  },
  methods: {
    warning(text, title){
      this.$vs.notify({
        title: title,
        text: text,
        color: "warning",
        position: "top-right"
      });
    },
    addSingle() {
      console.log(this.device_name)
      if (this.device_name !== ""){
        let payload = {
          name: this.device_name,
          notes: this.description
        };
        this.callback(payload);
        this.counter++
        this.name = ""
        this.description = ""
        this.isSidebarActiveLocal = false;
      }else{
        this.warning("Warning", "Device name cannot be empty!")
      }

    },
    generateDevice() {
      if (this.prefix_name !== "" && this.qty >0 ){
        this.disabled = true
        let payload = []
        let total = +this.qty + this.counter
        for (let i =this.counter; i < total; i++){
          payload.push({name:this.prefix_name+""+i, notes:this.description})
        }
        this.callback(payload);

        this.isSidebarActiveLocal = false;
      }else{
        if (this.prefix_name === "") this.warning("Warning", "Prefix name cannot be empty!")

        if (this.qty <1 ) this.warning("Warning", "Quantity cannot be empty")
      }

    }
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.centerx {
  display: -webkit-box;
  display: -ms-flexbox;
  margin-right: 5px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
